module.exports = __webpack_public_path__ + "img/data-bg.8b534e61.png";